import Alpine from "alpinejs";
import Accordion from "../modules/Accordion";
import ProductRegistrationForm from "../modules/ProductRegistrationForm";
import intersect from "@alpinejs/intersect";
import VariantDisplayBadges from "../modules/VariantDisplayBadges";
import HeaderNavigation from "../modules/HeaderNavigation";
import DateTimeUtils from "../modules/DateTimeUtils";
import PromotionHandler from "../modules/PromotionHandler";

window.Alpine = Alpine;

Alpine.plugin(intersect);
Alpine.data("ProductRegistrationForm", ProductRegistrationForm);
Alpine.data("Accordion", Accordion);
Alpine.data("VariantDisplayBadges", VariantDisplayBadges);
Alpine.data("HeaderNavigation", HeaderNavigation);
Alpine.data("DateTimeUtils", DateTimeUtils);
Alpine.data("PromotionHandler", PromotionHandler);

Alpine.start();
